import {ClientClass} from "@/openapi/generated";
import {roundDevicePixelRatio} from "@donista/shared/utils/device";

function getQueryParam(param: string) {
    if (typeof window === "undefined") {
        return null;
    }

    return new URL(window.location.href).searchParams.get(param);
}

export function getRedirectClick(
    targetUrl: string,
    userId: string | null | undefined,
    clientId: string | null | undefined,
    clientVersion: string | null | undefined,
    clientClass: ClientClass | null | undefined = ClientClass.WEBAPP
) {
    const isBrowser = typeof window !== "undefined";
    const hasNavigator = typeof navigator !== "undefined";
    const hasDocument = typeof document !== "undefined";
    const hasScreen = typeof screen !== "undefined";

    const resolvedClientClass = clientClass ?? ClientClass.WEBAPP;

    const clickData: Record<string, string | null | undefined> = {
        cc: resolvedClientClass,
        ut: Intl.DateTimeFormat().resolvedOptions().timeZone,
        ul: hasNavigator ? navigator.language : undefined,
        ref: hasDocument ? document.referrer : undefined,
        pu: isBrowser ? window.location.href : undefined,
        pt: hasDocument ? document.title : undefined,
        pa: "click",
        dw: isBrowser ? String(window.innerWidth) : undefined,
        dh: isBrowser ? String(window.innerHeight) : undefined,
        dp: isBrowser ? roundDevicePixelRatio(window.devicePixelRatio) : undefined,
        do: hasScreen && (screen as Screen & { orientation?: ScreenOrientation }).orientation?.type || undefined,
        dt: isBrowser && typeof window.matchMedia === "function"
            ? (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light")
            : undefined,
        utm_source: getQueryParam("utm_source"),
        utm_medium: getQueryParam("utm_medium"),
        utm_campaign: getQueryParam("utm_campaign"),
        utm_term: getQueryParam("utm_term"),
        utm_content: getQueryParam("utm_content"),
        gclid: getQueryParam("gclid"),
        gclsrc: getQueryParam("gclsrc"),
        wbraid: getQueryParam("wbraid"),
        gbraid: getQueryParam("gbraid"),
        dclid: getQueryParam("dclid"),
        fbclid: getQueryParam("fbclid"),
        li_fat_id: getQueryParam("li_fat_id"),
        msclkid: getQueryParam("msclkid"),
        ttclid: getQueryParam("ttclid"),
        twclid: getQueryParam("twclid"),
        yclid: getQueryParam("yclid"),
        clickid: getQueryParam("clickid"),
        cv: clientVersion ?? undefined,
        trg: targetUrl,
        ci: clientId ?? undefined,
        uid: userId ?? undefined
    };

    const queryString = Object.entries(clickData)
        .filter(([, value]) => value !== null && value !== undefined)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
        .join("&");

    return `${process.env.NEXT_PUBLIC_DONISTA_API_URL}/click?${queryString}`;
}
